export enum ProjectType {
  Edition = "edition",
  OneOfOne = "one-of-one",
}
